import type { TableFilterDropdownOptions } from "../table-filter.type";

import TableFilterIconSearch from "../table-filter-icon-search";

import TableFilterTextDropdown from "./table-filter-text.component";

export const TABLE_FILTER_TEXT: TableFilterDropdownOptions = {
  filterIcon: TableFilterIconSearch,
  filterDropdown: TableFilterTextDropdown,
};
